export const API_URL = {
  patientBan: 'patients/ban',
  patientUnban: 'patients/unban',
  patientIsTest: 'patients/update-is-test',
  /** DELETE /patients/:id — hard delete (POGONLINE-1161) */
  patientDelete: (id: string) => `/patients/${id}`,

  promoCodeCheck: 'promocodes/check-admin',

  sessionBrone: 'session-payment/book_by_admin',

  therapistsList: 'therapists/search/with_filter',
  therapistBan: 'therapists/ban',
  therapistUnban: 'therapists/unban',
  therapistApprove: 'therapists/approve',
  therapistUnapprove: 'therapists/unapprove',
  therapistIsTop: 'therapists/update-is-top',
  therapistIsTest: 'therapists/update-is-test',
  therapistIsAdult: 'therapists/update-is-adult',
  therapistIsChild: 'therapists/update-is-child-therapist',
  therapistIsSupervisor: 'therapists/update-is-supervisor',
  therapistIsMedsi: 'therapists/update-is-medsi',
  therapistIsB2B: 'therapists/update-is-b2b',
  therapistIsCoach: 'therapists/update-is-coach',
  therapistsExport: 'therapists/statistics',

  therapistsRequestVerify: (therapistId: string) =>
    `/therapists/requests/${therapistId}/verify`,
  therapistsRequestReject: (therapistId: string) =>
    `/therapists/requests/${therapistId}/reject`,

  therapistProfileUpdateAccept: (id: string) =>
    `/therapists/profile-updates/${id}/accept`,
  therapistProfileUpdateReject: (id: string) =>
    `/therapists/profile-updates/${id}/reject`,

  therapistById: (id: string) => `/therapists/${id}`,

  diseases: '/diseases',
  diseasesById: (id: string) => `/diseases/${id}`,
  diseasesGroup: '/diseases/group',
  diseasesGroupById: (id: string) => `/diseases/group/${id}`,

  faqGroup: '/faq/group',

  companyStatistic: (companyId: string, year: number) =>
    `/b2b/companies/${companyId}/statistics?year=${year}`,
  companyPromocodes: (companyId: string) =>
    `/b2b/companies/${companyId}/promocodes`,
  companyPatients: (companyId: string) =>
    `/b2b/companies/${companyId}/patients`,
  companyPatientById: (companyId: string, patientId: string) =>
    `/b2b/companies/${companyId}/patients/${patientId}`,
  editCompany: (companyId: string) => `/b2b/companies/${companyId}`,
  createCompany: '/b2b/companies/',
  archiveCompany: (companyId: string) => `/b2b/companies/${companyId}/archive`,
  unarchiveCompany: (companyId: string) =>
    `/b2b/companies/${companyId}/unarchive`,
  addPromocodes: (companyId: string) => `/promocodes`,
  addSessionBalances: '/session-balances',
  getCompanyRoles: (companyId: string) => `/b2b/companies/${companyId}/roles`,
  getCompanyGroups: (companyId: string) => `/b2b/companies/${companyId}/groups`,
  sessionsB2B: '/b2b/sessions',
  statsB2B: '/b2b/stats',
  statsB2BSessions: '/b2b/stats/sessions',
  companies: '/b2b/companies',
  b2bMaterials: '/b2b-materials',
  b2bMaterialById: (id: string) => `/b2b-materials/${id}`,
  b2bMaterialUpload: '/b2b-materials/upload',
  groupCallLinks: '/group-call-links',

  content: '/content',
  contentUpload: '/content/upload',
  contentItem: (id: string) => `/content/${id}`,
  contentReorder: '/content/reorder',
  contentCourses: '/content/courses',
  contentCourse: (id: string) => `/content/courses/${id}`,
  contentCourseRestore: (id: string) => `/content/courses/${id}/restore`,
  contentCoursesReorder: '/content/courses/reorder',
  contentFolders: '/content/folders',
  contentFolder: (id: string) => `/content/folders/${id}`,
  contentFoldersReorder: '/content/folders/reorder',
  contentFeedback: '/content/feedback',
  contentFeedbackItem: (id: string) => `/content/feedback/${id}`,
  contentFeedbackReply: (id: string) => `/content/feedback/${id}/reply`,
  contentFeedbackRead: (id: string) => `/content/feedback/${id}/read`,
  contentFeedbackUnreadCount: '/content/feedback/unread-count',
  contentFeedbackFilterOptions: '/content/feedback/filter-options',
  admins: '/admins',
  adminById: (id: string) => `/${id}`,

  getPublicAssignedUrl: '/get-public-signed-url',

  statisticsSessions: '/statistics/sessions',
  statisticsTherapistsExport: '/statistics/therapists',
  statisticsTherapistSessions: (therapistId: string) =>
    `/statistics/sessions/therapist/${therapistId}`,
  therapistSessions: '/sessions',
  getPromocodes: '/promocodes',
  getSessionBalances: '/session-balances',
  createReuseablePromocode: '/promocodes',
  updateReuseablePromocode: (id: string) => `/promocodes/${id}`,
  cancelSessionPayment: 'sessions',
  setSessionPromocodePaid: 'sessions/pay-promocode',
  setSessionPaymentPaid: 'sessions/pay-session',
  promotedSessionStatistics: '/promote',
  apiKey: '/api-keys',
  searchStatistics: '/search-statistics',
  clientsStatistics: 'statistics/sessions-clients',
  therapistUpdateRewardInPercent: 'therapists/update-reward-in-percent',
  therapistUpdateSessionPrice: 'therapists/update-session-price',
  therapistUpdateShortAbout: 'therapists/update-short-about',
  therapistUpdateAbout: 'therapists/update-about',
  therapistUpdateSpecialisation: 'therapists/update-specialisation',

  currencies: '/payment-gateway/currency',
  updateCurrency: '/payment-gateway/currency',

  createPaymentLink: '/payment-link',
  fetchPaymentLink: '/payment-link',

  uploadCompanyPatients: (companyId: string) =>
    `/b2b/companies/${companyId}/patients`,

  companyPatientBalanceList: (companyId: string, patientId: string) =>
    `/b2b/companies/${companyId}/patients/${patientId}/balance/list`,

  companyPatientBalanceStats: (companyId: string, patientId: string) =>
    `/b2b/companies/${companyId}/patients/${patientId}/balance/stats`,
};
